import { writable, get } from 'svelte/store';
import * as util from '../js/util.js';

var defaultStyle = 'euro'
var n = 1.1;
n = n.toLocaleString().substring(1, 2);
if (n == '.') {
    defaultStyle = 'noneuro'
}

function createMyStore() {
    const { subscribe, set, update } = writable({ style: defaultStyle, formatNumber: () => { } });
    var gettingTexts = false;
    var timeOut = null;
    var getKeys = [];
    return {
        subscribe, update,
        setEuroStyle: () => {
            numberFormatStore.update(n => Object.assign(n, { style: 'euro', formatNumber: n.formatNumber }))
        },
        setNonEuroStyle: () => {
            numberFormatStore.update(n => Object.assign(n, { style: 'noneuro', formatNumber: n.formatNumber }))
        },
        formatNumber: (amountIn,
            decimalCount = amountIn < 100 ? 6 : amountIn < 1000 ? 2 : 0,
            valueIf0 = '') => {
            let amount = amountIn
            var thousands = '.';
            var decimal = ',';
            if (!amount) return valueIf0;
            var store = get(numberFormatStore)
            if (store.style != 'euro') {
                thousands = ",";
                decimal = '.'
            }
            // var formatter = new Intl.NumberFormat('en-IN')
            // if (store.style == 'euro')
            //     formatter = new Intl.NumberFormat('nl-NL')
            //if(amount>1000000000) return formatNumber(amount/1000,0) + ' M'sync
            decimalCount = isNaN(decimalCount) ? 2 : decimalCount;
            //   return formatter.format(amount)
            const negativeSign = amount < 0 ? "-" : "";
            let i = parseInt(
                (amount = Math.abs(Number(amount) || 0).toFixed(decimalCount))
            ).toString();
            let j = i.length > 3 ? i.length % 3 : 0;
            var extraSpace = decimalCount == 6 ? "&nbsp;&nbsp;" : ""
            return (
                negativeSign +
                (j ? i.substr(0, j) + thousands : "") +
                i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + thousands) +
                (decimalCount
                    ? decimal +
                    Math.abs(amount - i)
                        .toFixed(decimalCount)
                        .slice(2)
                    : valueIf0)
            );
        }
    };
}
export const numberFormatStore = createMyStore();
numberFormatStore.update(n => Object.assign(n, { formatNumber: numberFormatStore.formatNumber }))